<template>

	<pharmacy-detail-page></pharmacy-detail-page>

</template>


<script>
import pharmacyDetailPage from './pharmacy-detail-page';

export default {

	components: {
		pharmacyDetailPage,
	},
}
</script>

<style scoped>
	.tabs /deep/ ul.tab-list li:last-child {
	  display: none !important;
	}

	.tabs.showTabApopoint /deep/ ul.tab-list li:last-child {
	  display: block !important;
	}

	.section {
	  margin: 0 0 25px 0;
	  padding: 16px;
	  width: 100%;
	  max-width: 1024px;
	  background-color: #F4f4f4;
	  border-radius: 4px;
	}


	.data-table-main table tr th,
	.data-table-main table tr td {
	  text-align: center;
	}

	.data-table-main table tr td:nth-last-child(-n+3) {
	  text-align: right;
	}

</style>
